import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'

import { Link } from 'react-router'

import StateIcon from '../../shared/components/StateIcon'
import Icon from '../../shared/components/Icon'

@inject('auth') @observer
export default class ListEntry extends Component {

  static propTypes = {
    auth: PropTypes.shape({
      acs: PropTypes.shape({
        isAuthorized: PropTypes.func.isRequired
      }).isRequired
    }).isRequired,
    editable: PropTypes.bool.isRequired,
    program: PropTypes.object.isRequired,
    showMuseum: PropTypes.bool
  }

  render() {
    const {
      auth, program, editable, showMuseum
    } = this.props
    const linkTo = editable
      ? `/program/${program.id}/edit`
      : `/program/${program.id}`
    const adminToolsLinkTo = `/program/${program.id}/admin`

    const isAdmin = auth.acs.isAuthorized('ADMIN')
    const isSuperAdmin = auth.acs.isAuthorized('SUPERADMIN')

    return (
      <li className="program iconized">
        <div className={program.temporarilyNotBookable ? 'faded' : ''}>
          <StateIcon
            item={program}
          />
          <Link to={linkTo}>
            {program.title}
&nbsp;
            {showMuseum ? `(${program.museum.name})` : null}
            {program.temporarilyNotBookable ? (
              <Icon
                className="inline"
                name="virus-turquoise"
                title={program.temporarilyNotBookableReason}
              />
            ) : null}
            {isAdmin && !program.isLive
              ? <strong>&nbsp;[Keine Live-Version]</strong>
              : null}
          </Link>
          <span className="tools">
            <Link to={linkTo}>
              <Icon
                className="tool-icon"
                size={18}
                name={`${editable ? 'pencil' : 'envelope'}-turquoise`}
              />
            </Link>
            {isSuperAdmin
              ? (
                <Link to={adminToolsLinkTo}>
                  <Icon
                    className="tool-icon"
                    size={18}
                    name="pencil-turquoise"
                  />
                </Link>
              )
              : null}
          </span>
        </div>
      </li>
    )
  }

}



// WEBPACK FOOTER //
// ./src/program/components/ListEntry.js